'use client';

import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '~/lib/utils';

const Progress = ({
  className,
  value,
  showIndicatorNotch,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {
  showIndicatorNotch?: boolean;
}) => (
  <ProgressPrimitive.Root
    className={cn(
      'relative h-4 w-full overflow-x-clip rounded-full bg-secondary',
      !showIndicatorNotch && 'overflow-hidden',
      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-primary transition-all"
      style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
    >
      {showIndicatorNotch && (
        <div className="absolute -top-0.5 right-0 z-10 flex">
          <div className="z-10 h-1.5 w-0.5 bg-primary"></div>
        </div>
      )}
    </ProgressPrimitive.Indicator>
  </ProgressPrimitive.Root>
);

export { Progress };
